import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";

interface Props {
  readonly open: boolean;
  readonly unresolvedCount: number;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
}

function UnresolvedLocationsDialog({
  open,
  unresolvedCount,
  onClose,
  onConfirm
}: Props) {
  const [t] = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {t("addressEncoding.unresolvedTitle", { count: unresolvedCount })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("addressEncoding.unresolvedMessage", { count: unresolvedCount })}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button
          color="success"
          onClick={onClose}
          style={{ marginRight: "10px" }}
        >
          {t("buttons.cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          autoFocus
          variant="contained"
          color="success"
        >
          {t("buttons.continueAnyway")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnresolvedLocationsDialog;
